import { useAtomValue, useSetAtom } from "jotai";
import { AuthFlows, AuthSteps } from "../../../constants/authSteps";
import { useAppSelector } from "../../../store/hooks";
import { Text } from "../../core-ui/components/Text/Text";
import { TextStyleVariant } from "../../core-ui/components/Text/TextUtils";
import { SignInForm } from "../SignInForm/SignInForm";
import { currentFlowAtom } from "../../../atoms/location/currentFlowAtom";
import {
  FormContainer,
  MainContentContainer,
  SignUpFooter,
} from "./AuthModal.styles";
import { AuthNavigation } from "./AuthNavigation";
import FooterContent from "./FooterContent";
import { currentSignUpStepAtom } from "../../../atoms/location/currentSignUpStepAtom";

export const UsernameSelection = () => {
  const flow = useAtomValue(currentFlowAtom);
  const isPhoneSignUp = flow === AuthFlows.PHONE_SIGNUP;
  const setAuthStep = useSetAtom(currentSignUpStepAtom);
  const { user } = useAppSelector((state) => state.accountInfo);

  if (!user) {
    setAuthStep(AuthSteps.START_LOGIN);
    return null;
  }

  return (
    <FormContainer>
      <AuthNavigation />
      <MainContentContainer>
        <Text variant={TextStyleVariant.H6}>Get your profile started</Text>
        <Text variant={TextStyleVariant.P1}>
          Add a username unique to you, this is how you&apos;ll appear to
          others. You can change your username at a later time in account
          settings.
        </Text>
        <SignInForm
          register={true}
          registerUsername={true}
          phoneLoginAddEmail={isPhoneSignUp}
        />
      </MainContentContainer>
      <SignUpFooter>
        <FooterContent />
      </SignUpFooter>
    </FormContainer>
  );
};
